import React from 'react';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { WalletTransaction, WalletTransactionType } from '@spike/wallet-model';
import styles from './WalletRow.module.scss';

export interface WalletRowProps {
    transaction: WalletTransaction;
}

const NEGATIVE_TYPES = new Set([WalletTransactionType.ReduceFunds, WalletTransactionType.Payment]);

function formatAmount(amount: number, type: WalletTransactionType): string {
    const abs = Math.abs(amount).toFixed(2);
    return NEGATIVE_TYPES.has(type) ? `-$${abs}` : `$${abs}`;
}

const WalletRow: React.FC<WalletRowProps> = ({ transaction }) => {
    const isNegative = NEGATIVE_TYPES.has(transaction.type);

    return (
        <TableRow>
            <TableCell>{transaction.date.format('MMM D, YYYY')}</TableCell>
            <TableCell>
                <span className={isNegative ? styles.negative : ''}>
                    {formatAmount(transaction.amount, transaction.type)}
                </span>
            </TableCell>
            <TableCell>{transaction.type}</TableCell>
            <TableCell>{transaction.staff ?? '—'}</TableCell>
        </TableRow>
    );
};

export default WalletRow;
